import axios from 'axios';

export default {
  namespaced: true,

  state: {
    updated: false,
    order: {},
    orders: []
  },

  getters: {
    getUpdated(state) {
      return state.updated;
    },
    order(state) {
      return state.order;
    }
  },

  mutations: {
    SET_UPDATED(state, value) {
      state.updated = value;
    },
    SET_ORDER(state, value) {
      state.order = value;
    },
    SET_ORDERS(state, value) {
      state.orders = value;
    }
  },

  actions: {
    updated({ commit }, value) {
      commit('SET_UPDATED', value);
    },
    async getOrder({ commit }, id) {
      await axios.get('/api/service-orders/' + id).then(res => {
        const order = res.data.data;
        commit('SET_ORDER', order);
      });
    }
  }
};
